import React from 'react';
import GroupStatusStatisticsPage from './GroupStatusStatisticsPage';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../../actions/report.actions';
import Loading from '../../../Helpers/Loading';
import Backend from '../../../Layouts/Backend';
import lookupActions from '../../../../actions/lookup.actions';
import helper from '../../../../utils/helper';
import { cloneDeep } from 'lodash';
import moment from 'moment';

class GroupStatusStatistics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groups: [],
      loading: false,
      isSubmitting: false,
      isFetching: false,
      errors: [],
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    let errors = prevState.errors;
    if (nextProps.lookup.groups !== prevState.groups) {
      state.groups = nextProps.lookup.groups;
    }
    // if (nextProps.configure.loading !== prevState.loading) {
    //   state.loading = nextProps.configure.loading;
    // }
    if (nextProps.report.isFetching !== prevState.isFetchingReport) {
      state.isFetchingReport = nextProps.report.isFetching;
    }
    state.errors = helper.centralizeError([nextProps.lookup.errors]);
    return Object.keys(state).length ? state : null;
  }

  async componentDidMount() {
    this.setState({ loading: true }, () =>
      this.props.lookupActions
        .getGroups()
        .finally(() => this.setState({ loading: false })),
    );
  }
  onGetReport = (values) => {
    const _values = cloneDeep(values);
    _values.typeIds = values.typeIds.join(',');
    this.props.reportActions.getGroupStatusStatistics(values);
  };
  render() {
    //prettier-ignore
    const { loading, isFetchingReport, errors, groups } = this.state;
    if (loading)
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    return (
      <GroupStatusStatisticsPage
        groups={groups}
        isFetchingReport={isFetchingReport}
        errors={errors}
        onGetReport={this.onGetReport}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
    report: state.report,
    lookup: state.lookup,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    reportActions: bindActionCreators(
      Object.assign({}, reportActions),
      dispatch,
    ),
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GroupStatusStatistics);
